import { render } from "./ConfirmationModal.vue?vue&type=template&id=42508ce8&scoped=true&ts=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=42508ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42508ce8"]])

export default __exports__